var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8757_80782",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2505 1.75024H1.75098V22.2498H22.2505V1.75024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8757_80782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8482 1.75024H4.15326C2.82652 1.75024 1.75098 2.82578 1.75098 4.15253V19.8475C1.75098 21.1742 2.82652 22.2498 4.15326 22.2498H19.8482C21.1749 22.2498 22.2505 21.1742 22.2505 19.8475V4.15253C22.2505 2.82578 21.1749 1.75024 19.8482 1.75024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 5.75415H18.1198L13.4901 11.0456L18.9366 18.246H14.672L11.3319 13.879L7.51 18.246H5.3896L10.3415 12.5863L5.1167 5.75415H9.48948L12.5087 9.74579L16.0006 5.75415ZM15.2569 16.9776H16.4311L8.85143 6.95593H7.59135L15.2569 16.9776Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9be14e42f75ca7e77b6e25007a337059.svg";
export { ForwardRef as ReactComponent };